/**
 * Use case: list customers with admin-portal filters/sort/pagination.
 *
 * The application layer depends only on the domain repository interface,
 * not on infrastructure. That makes it trivially unit-testable with an
 * in-memory fake (see tests/usecase.test.ts).
 */
import type { CustomerListRow } from '@domain/customer/Customer';
import type {
  CustomerRepository,
  ListPage,
  ListParams,
} from '@domain/customer/CustomerRepository';

export interface ListCustomersInput {
  search?: string;
  status?: string;
  cursor?: string;
  offset?: number;
  limit: number;
  sort?: { id: string; desc: boolean };
}

export const listCustomers = (repo: CustomerRepository) =>
  (input: ListCustomersInput): Promise<ListPage<CustomerListRow>> => {
    const filters: Record<string, string> = {};
    if (input.search) filters.search = input.search;
    if (input.status) filters.status = input.status;

    const params: ListParams = {
      limit: input.limit,
      offset: input.offset,
      cursor: input.cursor,
      sort: input.sort,
      filters,
    };
    return repo.list(params);
  };
